"use client";

import { Fragment, ReactNode, useEffect } from "react";

import { GoogleTagManagerInitiator } from "@/components/GoogleTagManagerInitiator";
import { Header } from "@/components/Header";
import { getQrSlugs } from "@/utils/qrSlug";
import { PATHS } from "@/internals/constants/paths";
import { usePrefetchRouter } from "@/hooks/navigation/usePrefetchRouter";
import { getCookie } from "@/services/CookiesService";
import { DOWNLOAD_QR_COOKIE } from "@/containers/AuthContainer/types";
import { redirect } from "next/navigation";
import { getSiteDomain } from "@/utils/site";
import { DomainName } from "@/sites/domains";

export default function EditorLayout({ children }: { children: ReactNode }) {
  const siteDomain = getSiteDomain();
  const isOnlineQrCode = siteDomain === DomainName.OnlineQRCode;

  useEffect(() => {
    const downladQR = getCookie(DOWNLOAD_QR_COOKIE);
    if (downladQR && isOnlineQrCode) {
      redirect(PATHS.MY_QR_CODES);
    }
  }, []);

  const getDynamicQrSlugRoutes = () => {
    const qrSlugs = getQrSlugs();
    const routes = qrSlugs.map((slug: string) => {
      return `${PATHS.QR_EDITOR}/${slug}`;
    });
    return routes;
  };
  usePrefetchRouter(getDynamicQrSlugRoutes());

  return (
    <Fragment>
      <GoogleTagManagerInitiator />
      <Header noNav />
      {children}
    </Fragment>
  );
}
